import { Pivot, PivotItem } from 'office-ui-fabric-react/lib/Pivot';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import { IAgent } from '../../../models/IAgent';
import { IAgentSpecificNegotiation } from '../../../models/IAgentSpecificNegotiation';
import { ITerms } from '../../../models/ITerms';
import ConnectionContext from '../../../utils/ConnectionContext';
import AgentCharges from '../AgentCharges/AgentCharges';
import AgentChargesUpdate from '../AgentChargesUpdate/AgentChargesUpdate';
import LandingPage from '../AgentHome/LandingPage';
import ContactInfo from '../Contact/ContactInfo';
import TermsServices from '../Terms/TermsServices';
import { IAgentDashboardProps } from './IAgentDashboardProps';
import { IAgentDashboardState } from './IAgentDashboardState';

const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '500px',
    padding: '10px',
    minWidth: '200px'
});
const headerPanel = mergeStyles({
    textAlign: "center", backgroundColor: "#006d79", color: "#FFFFFF", width: "100%", padding: "5px"
});
export default class AgentDashboard extends React.Component<IAgentDashboardProps, IAgentDashboardState>
{
    private connectionContext: ConnectionContext;
    constructor(props: IAgentDashboardProps, state: IAgentDashboardState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.state = {
            inputError: '',
            isValidData: false,
            loading: false,
            user: this.props.user,
            selectedTab: this.props.selectedTab || "",
            agent: {
                id: '',
                firmName: '',
                vatRegNo: '',
                emailId: '',
                firmAddress1: '',
                firmAddress2: '',
                city: '',
                state: '',
                countryCode: '',
                countryName: '',
                postalCode: '',
                contactPerson: '',
                companyEmail: '',
                phoneNumber: '',
                agentJurisdiction: []
            },
            terms: {
                id: '',
                agentId: '',
                employees: 0,
                trademarkAttorneys: 0,
                patentAttorneys: 0,
                lawAttorneys: 0,
                rpaLastYear: 0,
                papctLastYear: 0,
                rtaLastYear: 0,
                tamaLastYear: 0,
                tradeProsecRank: 0,
                patentProsecRank: 0,
                anyOtherAward: '',
                indemnityInsurance: '',
                iMaxAmount: 0,
                iCurrency: '',
                iAnnualAggregate: 0,
                aaCurrency: '',
                qtyMgmt: '',
                qtyMgmtStd: '',
                itSec: '',
                itSecStd: '',
                profConduct: '',
                conductCodes: '',
                docketingSystem: '',
                businessTerms: '',
                serviceTerms: false,
                ptoNames: [],
                technicalCompetenceAgent: []
            },
            negotiationRequests: []
        }
        this.checkAuthentication = this.checkAuthentication.bind(this);
    }
    public async componentDidMount() {
        this.getUserInformation();
    }
    private checkAuthentication = (): void => {
        this.props.isAuthenticated();
    }
    private homeToProfile = (): void => {
        this.setState({ selectedTab: "profile" });
    }
    private selectSelf = (item?: PivotItem, ev?: React.MouseEvent<HTMLElement>) => {
        if (item !== undefined) {
            this.setState({ selectedTab: item.props.itemKey || "home" });
        }
    }
    private getUserInformation = async (): Promise<void> => {
        try {

            let agent: IAgent | null = null;
            try {
                agent = await this.connectionContext.get(`Agent/${this.state.user.email}/agent`);
            } catch (exception) {
                agent = null;
            }

            let terms: ITerms | null = null;

            if (agent != null) {
                terms = await this.connectionContext.get(`Terms/${agent.id}`);
            }

            let negotiationRequests: IAgentSpecificNegotiation[] | null = null;

            if (agent != null) {
                negotiationRequests = await this.connectionContext.get(`AgentCharges/${agent.id}`);
            }

            this.setState((prevState: IAgentDashboardState): IAgentDashboardState => {

                if (agent != null) {
                    prevState.agent = agent;
                }

                if (terms != null) {
                    prevState.terms = terms;
                }

                if (negotiationRequests != null) {
                    prevState.negotiationRequests = negotiationRequests;
                }
                prevState.selectedTab = prevState.agent.id === "" ? "home" : (prevState.terms.id === "" ? "terms" : (prevState.negotiationRequests.length > 0 ? "revision" : "charges"));
                return prevState;
            });
        } catch (error) {
            this.setState((prevState: IAgentDashboardState): IAgentDashboardState => {
                prevState.selectedTab = "profile";
                return prevState;
            });
        }
    }
    public render(): React.ReactElement<IAgentDashboardProps> {
        const { selectedTab } = this.state;
        return (
            <div className={panel}>
                <div className={headerPanel}>
                    <h6>Welcome to Zacco's agent network</h6><h6>Your registered email address : {this.state.user.email}</h6>
                </div>
                <div>
                    <Pivot defaultSelectedKey={selectedTab} selectedKey={selectedTab} onLinkClick={this.selectSelf}>
                        <PivotItem headerText="Home" itemKey={"home"} accessKey={"home"} itemIcon={"Home"} >
                            <LandingPage connectionContext={this.connectionContext} isAuthenticated={this.homeToProfile} />
                        </PivotItem>
                        <PivotItem headerText="Profile" itemKey={"profile"} accessKey={"profile"} itemIcon={"ContactInfo"} >
                            <ContactInfo connectionContext={this.connectionContext} agentMaster={this.state.agent} user={this.state.user} isAuthenticated={this.checkAuthentication} />
                        </PivotItem>
                        {this.state.agent.id && (
                            <PivotItem headerText="Terms" itemKey={"terms"} accessKey={"terms"} itemIcon={"EntitlementPolicy"} >
                                <TermsServices connectionContext={this.connectionContext} agentMaster={this.state.agent} terms={this.state.terms} user={this.state.user} isAuthenticated={this.checkAuthentication} />
                            </PivotItem>)
                        }
                        {this.state.terms.id && (
                            <PivotItem headerText="Charges" itemKey={"charges"} accessKey={"charges"} itemIcon={"AllCurrency"}>
                                <AgentCharges connectionContext={this.connectionContext} agentMaster={this.state.agent} />
                            </PivotItem>)
                        }
                        {this.state.negotiationRequests.length > 0 && (
                            <PivotItem headerText="Revision" itemKey={"revision"} accessKey={"revision"} itemIcon={"Money"}>
                                <AgentChargesUpdate connectionContext={this.connectionContext} agentMaster={this.state.agent} />
                            </PivotItem>)
                        }
                    </Pivot>
                </div>
            </div>
        );
    }
}
